import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="text-center box-shadow p-1 fs-6">
            <p className="mt-3">Copyright &copy; 2021 built with <span className="pink">&hearts;</span> by Md. Rifat Islam</p>
        </footer>
    );
};

export default Footer;